export const valueToInt = value => isNaN(parseInt(value)) ? "" : parseInt(value);